// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Currency from "../../../../../library/data-source/country-currency/Currency.bs.js";
import * as Caml_option from "../../../../../../node_modules/rescript/lib/es6/caml_option.js";

var emptyVMData_vehicle_imgs = {
  map_marker: "",
  selected: "",
  deselected: ""
};

var emptyVMData_details = [];

var emptyVMData_goods_type = [];

var emptyVMData_fare_info = {
  fare: Currency.toCurrency(0.0),
  min_paytm_amount: Currency.toCurrency(0.0),
  min_paytm_amount_with_credits: Currency.toCurrency(0.0),
  applied_coupon: undefined,
  subscription_discount: undefined,
  total_discount: Currency.toCurrency(0.0),
  description: undefined
};

var emptyVMData_bill_details = {
  fare_breakup: [/* None */0],
  net_fare: Currency.toCurrency(0.0),
  previous_dues: Caml_option.some(Currency.toCurrency(0.0)),
  porter_gold_fee: undefined,
  porter_credits_applied: undefined,
  amount_payable: Currency.toCurrency(0.0)
};

var emptyVMData = {
  vehicle_id: -1,
  vehicle_name: "",
  vehicle_imgs: emptyVMData_vehicle_imgs,
  quotation_uuid: "",
  details: emptyVMData_details,
  goods_type: emptyVMData_goods_type,
  nearby_vehicles: 0,
  eta_mins: 0,
  fare_info: emptyVMData_fare_info,
  bill_details: emptyVMData_bill_details
};

function getVehicleBaseFare(quotation) {
  var bill = quotation.bill_details;
  var tripFare = bill !== undefined ? Caml_option.undefined_to_opt(bill.fare_breakup.find(function (fare) {
              if (typeof fare === "number" || fare.TAG !== /* TripFare */0) {
                return false;
              } else {
                return true;
              }
            })) : undefined;
  if (tripFare !== undefined) {
    if (typeof tripFare === "number") {
      return Currency.toCurrency(0.0);
    } else if (tripFare.TAG === /* TripFare */0) {
      return tripFare._0.value;
    } else {
      return Currency.toCurrency(0.0);
    }
  } else {
    return Currency.toCurrency(0.0);
  }
}

function getAvailableNearbyVehicles(quotations) {
  return quotations.nearby_vehicle_drivers.filter(function (q) {
              return q.show_vehicle;
            });
}

function getVehicleDetails(vehicleId, onDemandVehicles) {
  return Caml_option.undefined_to_opt(onDemandVehicles.find(function (v) {
                  return v.id === vehicleId;
                }));
}

function getVehicleQuotationDetails(vehicleId, vehicleQuotations) {
  return Caml_option.undefined_to_opt(vehicleQuotations.find(function (v) {
                  return v.vehicle_id === vehicleId;
                }));
}

function getVM(onDemandVehicles, quotations) {
  var availableNearbyVehicles = getAvailableNearbyVehicles(quotations);
  var nearbyVehicles = availableNearbyVehicles.map(function (v) {
        var vehicleDetails = getVehicleDetails(v.vehicle_id, onDemandVehicles);
        var vehicleQuotationDetails = getVehicleQuotationDetails(v.vehicle_id, quotations.vehicle_wise_quotations);
        if (vehicleDetails === undefined) {
          return emptyVMData;
        }
        if (vehicleQuotationDetails === undefined) {
          return emptyVMData;
        }
        var m = v.eta_mins;
        var fareInfo = vehicleQuotationDetails.fare_info;
        var billDetails = vehicleQuotationDetails.bill_details;
        return {
                vehicle_id: v.vehicle_id,
                vehicle_name: vehicleDetails.display_name,
                vehicle_imgs: vehicleDetails.icons,
                quotation_uuid: vehicleQuotationDetails.quotation_uuid,
                details: vehicleDetails.details,
                goods_type: vehicleDetails.allowed_goods_type_names,
                nearby_vehicles: v.driver_locs.length,
                eta_mins: m !== undefined ? m : 0,
                fare_info: fareInfo !== undefined ? fareInfo : emptyVMData_fare_info,
                bill_details: billDetails !== undefined ? billDetails : emptyVMData_bill_details
              };
      });
  return nearbyVehicles.filter(function (vehicle) {
              return vehicle.vehicle_id !== -1;
            });
}

export {
  emptyVMData ,
  getVehicleBaseFare ,
  getAvailableNearbyVehicles ,
  getVehicleDetails ,
  getVehicleQuotationDetails ,
  getVM ,
  
}
/* emptyVMData Not a pure module */
